import { BonusItem } from "types/Bonus";

export const welcomeBonusText = {
  reward: "100%",
  bonusReward: "125%",
  spinsReward: "+250 Free Spins",
  backTitle: "125% + 250 Free Spins",
};

export enum WELCOME_ITEM {
  MIN,
  MAX,
  FREE_SPINS,
  BONUS_HOURS,
  SPIN_HOURS,
  CATEGORY,
  WAGER,
}

export const WELCOME_BONUS_LIST_ITEM: BonusItem[] = [
  {
    id: WELCOME_ITEM.MIN,
    name: "bonus.welcome.card.deposit.minimum",
    value: "bonus.welcome.card.deposit.min",
  },
  {
    id: WELCOME_ITEM.MAX,
    name: "bonus.welcome.card.deposit.maximum",
    value: "bonus.welcome.card.deposit.max",
  },
  {
    id: WELCOME_ITEM.FREE_SPINS,
    name: "+250 Free Spins",
    value: "bonus.welcome.card.spin.min",
  },
  {
    id: WELCOME_ITEM.BONUS_HOURS,
    name: "bonus.welcome.card.bonus.time",
    value: "bonus.welcome.card.bonus.hours",
  },
  {
    id: WELCOME_ITEM.SPIN_HOURS,
    name: "bonus.welcome.card.spin.time",
    value: "bonus.welcome.card.spin.hours",
  },
  {
    id: WELCOME_ITEM.CATEGORY,
    name: "bonus.back.category",
    value: "casino.sidebar.slots",
  },
  { id: WELCOME_ITEM.WAGER, name: "bonus.back.wager", value: "x50" },
];
